import React, { createContext, useContext, useState } from 'react';

// Create the context
const DoctorContext = createContext();

// Context provider component
export const DoctorContextProvider = ({ children }) => {
  const [hasClinics, setHasClinics] = useState(false);
  const [hasServices, setHasServices] = useState(false);
  const [hasBlogs, setHasBlogs] = useState(false);
  const [hasOffers, setHasOffers] = useState(false);
  const [hasNews, setHasNews] = useState(false);
  const [hasDoctors,setHasDoctors]=useState(false)
  const [hasReviews,setHasReviews]=useState(false)

  const value = {
    hasClinics,
    setHasClinics,
    hasServices,
    setHasServices,
    hasBlogs, 
    setHasBlogs,
    hasOffers,
    setHasOffers,
    hasNews,
    setHasNews,
    hasDoctors,
    setHasDoctors,
    hasReviews,
    setHasReviews
  };

  return (
    <DoctorContext.Provider value={value}>
      {children}
    </DoctorContext.Provider>
  );
};

// Custom hook to use the context
export const useDoctorContext = () => {
  const context = useContext(DoctorContext);
  
  if (!context) {
    throw new Error('useAppContext must be used within an AppContextProvider');
  }
  
  return context;
};